/**
 * 首页地图检索
 */
import { pbrAxios } from '../../common/js/pbrAxios'

/**
 * 首页——获取检索条件数据接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: 空值或cn是中文，其他为英文
 *    @param {Number}paramas.type:  fx：风险  sj：商机  xm或其他：项目条件
 * @returns {AxiosPromise<any>}
 */
const fetchMapGConditions = params => {
  return pbrAxios.post('/front/home/gconditions', params)
}

/**
 * 首页——地图图表检索数据接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from:  en：英文数据  其他是中文数据
 *    @param {String}params.module: 模块分类 sj|xm|fx 分表代表商机|项目|风险  其他值或者空值则是全部检索
 *    @param {String}params.country: 国家编号
 *    @param {String}params.category: 检索条件类型  项目类型|风类型|商机类型 对于的编号
 *    @param {String}params.date:日期检索条件编号
 *    @param {String}params.industry: 行业编号
 *    @param {String}params.company: 企业编号
 *    @param {String}params.amount: 金额编号
 *    @param {String}params.stage: 阶段编号
 *    @param {String}params.keywords: 关键字
 *    @param {String}params.ids: 项目|风险|商机编号
 *    @param {String}params.searchKeys: 检索条件数组
 * @returns {AxiosPromise<any>}
 */
const fetchMapObject = params => {
  return pbrAxios.post('/front/home/search', params)
}

/**
 * 首页——获取项目|风险|商机数据接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from: en：英文  cn：中文  其他：中文
 *    @param {String}params.module: sj：商机数据  fx：风险事件数据  xm：项目数据
 *    @param {Number}paramas.pagesize: 每页显示条数
 *    @param {Number}paramas.currentpage: 当前页
 * @returns {AxiosPromise<any>}
 */
const fetchMapTableInfos = params => {
  return pbrAxios.post('/front/home/ginfos', params)
}

export default {
  fetchMapGConditions,
  fetchMapObject,
  fetchMapTableInfos
}
